export const CREATE_ERROR = 'CREATE_ERROR';
export const HIDE_ERROR = 'HIDE_ERROR';
